import { useState, useEffect } from 'react';
import callOysterApi from '../utils/call-oyster-api.js';

function truthyRoleFlag(value) {
    if (value === true) return true;
    if (value === false || value == null) return false;
    if (typeof value === 'number') return value === 1;
    if (typeof value === 'string') {
        const s = value.trim().toLowerCase();
        return s === 'true' || s === '1' || s === 'yes';
    }
    return false;
}

const useCurrentUser = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await callOysterApi('/users/me', 'GET');
                if (response.ok) {
                    const data = await response.json();
                    if (data.success) {
                        setUser(data.payload);
                    }
                } else {
                    // Start soft failure if not found (e.g. 401)
                    console.error('Failed to fetch current user');
                }
            } catch (err) {
                console.error('Error fetching current user:', err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, []);

    const isLeadership = truthyRoleFlag(user?.isItLeadership);
    const isTeamLead = truthyRoleFlag(user?.isTeamLead);
    const executivePulseAccess = !!user?.executivePulseAccess;
    const isDev = process.env.NODE_ENV === 'development';
    const canManageTeams = isDev || isLeadership || isTeamLead;
    /** Weekly audit UI + `/reporting/weekly-audit/*` (team leads + IT leadership). */
    const canAccessWeeklyAudit = !!(isLeadership || isTeamLead);

    return {
        user,
        loading,
        error,
        isLeadership,
        isTeamLead,
        executivePulseAccess,
        canManageTeams,
        canAccessWeeklyAudit,
        isDev
    };
};

export default useCurrentUser;
